/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Nda_Dismissed13Inputs */

const en_coinvestments_audit_event_nda_dismissed13 = /** @type {(inputs: Coinvestments_Audit_Event_Nda_Dismissed13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA Dismissed`)
};

/**
* | output |
* | --- |
* | "NDA Dismissed" |
*
* @param {Coinvestments_Audit_Event_Nda_Dismissed13Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_nda_dismissed13 = /** @type {((inputs?: Coinvestments_Audit_Event_Nda_Dismissed13Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Nda_Dismissed13Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_nda_dismissed13(inputs)
});
export { coinvestments_audit_event_nda_dismissed13 as "coInvestments_audit_event_NDA_DISMISSED" }